var assocIndexOf = require('./_assocIndexOf');

/**
 * Sets the associative array `key` to `value`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 */
function assocSet(array, key, value) {
  var index = assocIndexOf(array, key);
  if (index < 0) {
    array.push([key, value]);
  } else {
    array[index][1] = value;
  }
}

module.exports = assocSet;



/*****************
 ** WEBPACK FOOTER
 ** ./~/lodash/_assocSet.js
 ** module id = 54
 ** module chunks = 2 3 4 8 9 10 12 13 14
 **/